import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { appConfig } from "../interface/MainInterface";

export class CommonUtils {
  public dateFormat = (value: string, iPattern: string, oPattern: string) => {
    return dayjs(value, iPattern).format(oPattern);
  };

  public convertSecToTime = (timeInSeconds: number) => {
    let hours: any = Math.floor(timeInSeconds / 3600);
    let minutes: any = Math.floor((timeInSeconds - hours * 3600) / 60);
    let seconds: any = Math.floor(timeInSeconds - hours * 3600 - minutes * 60);

    if (hours < 10) {
      hours = "0" + hours;
    }

    if (hours > 99) {
      hours = this.numericComma(Number(hours));
    }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return {
      hours: "" + hours,
      minutes: "" + minutes,
      seconds: "" + seconds,
    };
  };

  public isEmptyObj(obj: any) {
    if (obj === null || obj === undefined) return true;
    if (obj.constructor === Object && Object.keys(obj).length > 0) {
      return false;
    }

    return true;
  }

  public numericComma = (value: any) => {
    if (typeof value === "number") {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else if(typeof value === "string") {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return undefined;
  };

  public downloadExcel = (sheetContent: any, colWidth: any, sheetName: string, fileName: string, merge?: any) => {
    const sheet: any = XLSX.utils.aoa_to_sheet(sheetContent);
    sheet["!cols"] = colWidth;
    if (merge) sheet["!merges"] = merge;
    const chatFile = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(chatFile, sheet, sheetName);
    XLSX.writeFile(chatFile, fileName);
  };

  public calculateWindowSize = (windowWidth: number) => {
    if (windowWidth >= 1200) {
      return "lg";
    }
    if (windowWidth >= 992) {
      return "md";
    }
    if (windowWidth >= 768) {
      return "sm";
    }
    return "xs";
  };

  public calRemainSec = (startTime: string) => {
    const now = dayjs();
    const dateDiff = dayjs(startTime, "YYYYMMDDHHmmss").diff(now, "s");
    return dateDiff;
  };

  public calPassedSec = (startTime: string) => {
    const now = dayjs();
    const dateDiff = now.diff(dayjs(startTime, "YYYYMMDDHHmmss"), "s");
    return dateDiff;
  };

  // 국가코드별 국기 이미지 생성기
  public makeCtryFlagUrl = (code: string) => {
    return `${process.env.REACT_APP_DT_IMAGE_DOMAIN}/images/aihdt/flag/flag_${code.toLowerCase()}.png`;
  };

  public maskingChar = (strCar: string) => {
    if (strCar === undefined || strCar === "") {
      return "";
    }
    if (appConfig.chat_id_mask) {
      let rtn_text: string = strCar.substring(0, 3) + "".padEnd(strCar.substring(3, 6).length, "*");
      if (strCar.length > 6) rtn_text = rtn_text + "...";
      return rtn_text;
    } else return strCar;
  };
}
